<p class="text-lg font-semibold mb-xl">
  {{ 'user_form_screen_quick_create_job_title_title' | transloco }}
</p>

<form [formGroup]="formGroup" class="flex flex-col gap-lg">
  <div class="grid grid-cols-2 gap-lg">
    <div class="col-span-2">
      <div formGroupName="name">
        <lib-dual-lang-input
          [requiredGroup]="true"
          [inputFormControlName]="'name'"
          [id]="'quick_create_job_title_name'"
          type="text"
          name="name"
          [requiredEn]="false"
          [requiredAr]="false"
          [label]="'job_titles_form_job_title_name_label' | transloco"
          [placeholderEn]="
            'job_titles_form_job_title_name_placeholder_en' | transloco
          "
          [placeholderAr]="
            'job_titles_form_job_title_name_placeholder_ar' | transloco
          " />
      </div>
      <lib-validation-message
        [lang]="'current_lang' | transloco"
        control="name" />
    </div>

    <div>
      <lib-input
        [inputFormControlName]="'identifier'"
        [id]="'quick_create_job_title_identifier'"
        type="text"
        name="identifier"
        [label]="'job_titles_form_job_title_id_label' | transloco"
        [placeholder]="'id_input_default_placeholder' | transloco" />
      <lib-validation-message
        [lang]="'current_lang' | transloco"
        control="identifier" />
    </div>

    <div>
      <lib-paginated-select
        [id]="'quick_create_job_title_track_option_id'"
        [inputFormControlName]="'track_option_id'"
        [name]="'track_option_id'"
        [label]="'job_titles_form_track_label' | transloco"
        [placeholder]="'job_titles_form_track_placeholder' | transloco"
        [apiUrl]="variableOptionsApi"
        [filters]="trackFilter"
        [noDataLabel]="'user_dropdown_input_no_data_label' | transloco" />
      <lib-validation-message
        [lang]="'current_lang' | transloco"
        control="track_option_id" />
    </div>

    <div>
      <lib-paginated-select
        [id]="'quick_create_job_title_radford_grade_option_id'"
        [inputFormControlName]="'radford_grade_option_id'"
        [name]="'radford_grade_option_id'"
        [label]="'job_titles_form_radford_grade_label' | transloco"
        [placeholder]="'job_titles_form_radford_grade_placeholder' | transloco"
        [apiUrl]="variableOptionsApi"
        [filters]="radfordGradeFilter"
        [noDataLabel]="'user_dropdown_input_no_data_label' | transloco" />
      <lib-validation-message
        [lang]="'current_lang' | transloco"
        control="radford_grade_option_id" />
    </div>

    <div>
      <lib-paginated-select
        [id]="'quick_create_job_title_job_family_option_id'"
        [inputFormControlName]="'job_family_option_id'"
        [name]="'job_family_option_id'"
        [label]="'job_titles_form_job_family_label' | transloco"
        [placeholder]="'job_titles_form_job_family_placeholder' | transloco"
        [apiUrl]="variableOptionsApi"
        [filters]="jobFamilyFilter"
        [noDataLabel]="'user_dropdown_input_no_data_label' | transloco" />
      <lib-validation-message
        [lang]="'current_lang' | transloco"
        control="job_family_option_id" />
    </div>
  </div>

  <div class="flex gap-md justify-end mt-lg">
    <button
      type="button"
      class="text-neutral-700 bg-white border border-neutral-300 py-sm px-xl rounded-md text-base cursor-pointer"
      (click)="cancel()">
      {{ 'quick_create_cancel_button_label' | transloco }}
    </button>
    <button
      type="button"
      [class.opacity-30]="isLoading()"
      [disabled]="isLoading()"
      class="bg-primary-500 py-sm px-xl rounded-md text-white text-base cursor-pointer"
      (click)="submit()">
      {{ 'quick_create_save_button_label' | transloco }}
    </button>
  </div>
</form>
